module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** member Widget */

/** Layout Member */

(function(fox) {

	fox.registerWidget('Member', {

		//Widget config
		configure: function(options) {
			this.callParent('configure', arguments);
		},

		rendering: function() {
			if (fox.isEmpty(fox.site.member)) {
				return this.createFragment();
			}
			return this.callParent('rendering', arguments);
		}
	});

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/member.js
// module id = 1128
// module chunks = 4